
import AppButton from "./AppButton"
export default {
  components: {
    AppButton
  },
  props: {
    image: {
      type: Object,
      required: true
    },
    tag: {
      type: String,
      required: false
    },
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: true
    },
    linkObj: {
      type: Object, // Storyblok Link Object.
      required: true
    },
    noBorder: {
      type: Boolean,
      default: false
    },
    noBackground: {
      type: Boolean,
      default: false
    },
    blackAndWhiteImage: {
      type: Boolean,
      default: false
    },
    buttonVariant: {
      type: String,
      default: "invertedPrimary"
    },
    titleLarge: {
      type: Boolean,
      default: false
    },
    variant: {
      type: String,
      default: "default",
      validator(value) {
        return ["small", "default", ""].includes(value)
      }
    }
  },
  computed: {
    linkAttrs() {
      if (!this.linkObj) {
        return {}
      } else if (this.linkObj.linktype === "url") {
        return {
          href: this.linkObj.url,
          target: this.linkObj.url ? "_blank" : null
        }
      } else if (this.linkObj.linktype === "story") {
        return { to: this.linkObj.cached_url }
      }
      return {}
    }
  }
}
